// This file is auto-generated by scripts/build/index.ts
// Do not edit manually

export interface Template {
	name: string;
	displayName: string;
	description: string;
	technologies: string[];
	tags: string[];
	noFrontend: boolean;
	priority?: number;
	providers: {
		[key: string]: {
			name: string;
			deployUrl: string;
		};
	}
}

export const templates: Template[] = [
  {
    "name": "ai-agent",
    "displayName": "AI Agent Chat",
    "description": "Example project demonstrating AI agent integration.",
    "technologies": [
      "rivet",
      "typescript"
    ],
    "tags": [
      "ai",
      "real-time"
    ],
    "noFrontend": false,
    "priority": 100,
    "providers": {
      "vercel": {
        "name": "ai-agent-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fai-agent-vercel&project-name=ai-agent-vercel"
      }
    }
  },
  {
    "name": "hello-world",
    "displayName": "Hello World",
    "description": "A minimal example demonstrating RivetKit with a real-time counter shared across multiple clients.",
    "technologies": [
      "rivet",
      "react",
      "typescript"
    ],
    "tags": [
      "starter"
    ],
    "noFrontend": false,
    "priority": 100,
    "providers": {
      "vercel": {
        "name": "hello-world-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fhello-world-vercel&project-name=hello-world-vercel"
      }
    }
  },
  {
    "name": "chat-room",
    "displayName": "Chat Room",
    "description": "Example project demonstrating real-time messaging and actor state management.",
    "technologies": [
      "rivet",
      "react",
      "typescript"
    ],
    "tags": [
      "real-time"
    ],
    "noFrontend": false,
    "priority": 200,
    "providers": {
      "vercel": {
        "name": "chat-room-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fchat-room-vercel&project-name=chat-room-vercel"
      }
    }
  },
  {
    "name": "cursors",
    "displayName": "Real-time Collaborative Cursors",
    "description": "Example project demonstrating real-time cursor tracking and collaborative canvas.",
    "technologies": [
      "rivet",
      "react",
      "typescript"
    ],
    "tags": [
      "real-time"
    ],
    "noFrontend": false,
    "priority": 300,
    "providers": {
      "vercel": {
        "name": "cursors-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fcursors-vercel&project-name=cursors-vercel"
      }
    }
  },
  {
    "name": "ai-and-user-generated-actors-freestyle",
    "displayName": "User and AI Generated Actors Freestyle Deployer",
    "description": "Shows how to deploy user or AI-generated Rivet Actor code using a sandboxed namespace and Freestyle",
    "technologies": [
      "rivet",
      "react",
      "hono",
      "typescript"
    ],
    "tags": [
      "ai"
    ],
    "noFrontend": false,
    "priority": 400,
    "providers": {}
  },
  {
    "name": "actor-actions",
    "displayName": "Actor Actions",
    "description": "Demonstrates how to define and call actions on Rivet Actors for RPC-style communication between actors and clients.",
    "technologies": [
      "rivet",
      "typescript"
    ],
    "tags": [],
    "noFrontend": false,
    "priority": 1000,
    "providers": {
      "vercel": {
        "name": "actor-actions-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Factor-actions-vercel&project-name=actor-actions-vercel"
      }
    }
  },
  {
    "name": "cross-actor-actions",
    "displayName": "Cross-Actor Actions",
    "description": "Demonstrates how actors can call actions on other actors for inter-actor communication and coordination.",
    "technologies": [
      "rivet",
      "typescript"
    ],
    "tags": [],
    "noFrontend": false,
    "priority": 1000,
    "providers": {
      "vercel": {
        "name": "cross-actor-actions-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fcross-actor-actions-vercel&project-name=cross-actor-actions-vercel"
      }
    }
  },
  {
    "name": "multi-region",
    "displayName": "Multi-Region",
    "description": "Demonstrates deploying Rivet Actors across multiple geographic regions for low-latency global access.",
    "technologies": [
      "rivet",
      "typescript"
    ],
    "tags": [],
    "noFrontend": false,
    "priority": 1000,
    "providers": {
      "vercel": {
        "name": "multi-region-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fmulti-region-vercel&project-name=multi-region-vercel"
      }
    }
  },
  {
    "name": "raw-fetch-handler",
    "displayName": "Raw Fetch Handler Example",
    "description": "Example project demonstrating raw HTTP fetch handling with Hono integration.",
    "technologies": [
      "rivet",
      "typescript"
    ],
    "tags": [],
    "noFrontend": false,
    "priority": 1000,
    "providers": {
      "vercel": {
        "name": "raw-fetch-handler-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fraw-fetch-handler-vercel&project-name=raw-fetch-handler-vercel"
      }
    }
  },
  {
    "name": "raw-websocket-handler",
    "displayName": "Raw WebSocket Handler",
    "description": "Demonstrates raw WebSocket handling with direct actor connections and real-time chat functionality.",
    "technologies": [
      "rivet",
      "websocket",
      "typescript"
    ],
    "tags": [
      "real-time"
    ],
    "noFrontend": false,
    "priority": 1000,
    "providers": {
      "vercel": {
        "name": "raw-websocket-handler-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fraw-websocket-handler-vercel&project-name=raw-websocket-handler-vercel"
      }
    }
  },
  {
    "name": "scheduling",
    "displayName": "Scheduling",
    "description": "Demonstrates how to schedule tasks and execute code at specific times or intervals using Rivet Actors.",
    "technologies": [
      "rivet",
      "typescript"
    ],
    "tags": [],
    "noFrontend": false,
    "priority": 1000,
    "providers": {
      "vercel": {
        "name": "scheduling-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fscheduling-vercel&project-name=scheduling-vercel"
      }
    }
  },
  {
    "name": "state",
    "displayName": "State Management",
    "description": "Demonstrates persistent state management in Rivet Actors with automatic state saving and restoration.",
    "technologies": [
      "rivet",
      "typescript"
    ],
    "tags": [],
    "noFrontend": false,
    "priority": 1000,
    "providers": {
      "vercel": {
        "name": "state-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fstate-vercel&project-name=state-vercel"
      }
    }
  },
  {
    "name": "cloudflare-workers",
    "displayName": "Cloudflare Workers",
    "description": "Example project demonstrating Cloudflare Workers deployment.",
    "technologies": [
      "rivet",
      "cloudflare-workers",
      "typescript"
    ],
    "tags": [],
    "noFrontend": true,
    "providers": {}
  },
  {
    "name": "cloudflare-workers-hono",
    "displayName": "Cloudflare Workers with Hono",
    "description": "Example project demonstrating Cloudflare Workers deployment with Hono router.",
    "technologies": [
      "rivet",
      "cloudflare-workers",
      "hono",
      "typescript"
    ],
    "tags": [],
    "noFrontend": true,
    "providers": {}
  },
  {
    "name": "cursors-raw-websocket",
    "displayName": "Real-time Collaborative Cursors (Raw WebSocket)",
    "description": "Demonstrates real-time cursor tracking and collaborative canvas using raw WebSocket handlers instead of RivetKit's higher-level WebSocket abstraction.",
    "technologies": [
      "rivet",
      "websocket",
      "typescript"
    ],
    "tags": [
      "real-time"
    ],
    "noFrontend": false,
    "providers": {
      "vercel": {
        "name": "cursors-raw-websocket-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fcursors-raw-websocket-vercel&project-name=cursors-raw-websocket-vercel"
      }
    }
  },
  {
    "name": "custom-serverless",
    "displayName": "Custom Serverless",
    "description": "Example demonstrating custom serverless actor deployment with automatic engine configuration.",
    "technologies": [
      "rivet",
      "typescript"
    ],
    "tags": [
      "starter"
    ],
    "noFrontend": true,
    "providers": {
      "vercel": {
        "name": "custom-serverless-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fcustom-serverless-vercel&project-name=custom-serverless-vercel"
      }
    }
  },
  {
    "name": "drizzle",
    "displayName": "Drizzle Integration",
    "description": "Demonstrates Drizzle ORM integration with Rivet Actors for type-safe database operations.",
    "technologies": [
      "rivet",
      "drizzle",
      "typescript"
    ],
    "tags": [
      "database"
    ],
    "noFrontend": true,
    "providers": {}
  },
  {
    "name": "elysia",
    "displayName": "Elysia Integration",
    "description": "Example project demonstrating Elysia web framework integration.",
    "technologies": [
      "rivet",
      "elysia",
      "typescript"
    ],
    "tags": [],
    "noFrontend": true,
    "providers": {
      "vercel": {
        "name": "elysia-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Felysia-vercel&project-name=elysia-vercel"
      }
    }
  },
  {
    "name": "experimental-durable-streams-ai-agent",
    "displayName": "AI Agent with Durable Streams (Experimental)",
    "description": "Example project demonstrating how to build an AI agent that communicates through durable streams for reliable message delivery and persistence.",
    "technologies": [
      "rivet",
      "typescript",
      "durable-streams"
    ],
    "tags": [
      "ai",
      "real-time",
      "experimental"
    ],
    "noFrontend": false,
    "providers": {
      "vercel": {
        "name": "experimental-durable-streams-ai-agent-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fexperimental-durable-streams-ai-agent-vercel&project-name=experimental-durable-streams-ai-agent-vercel"
      }
    }
  },
  {
    "name": "hono",
    "displayName": "Hono Integration",
    "description": "Example project demonstrating Hono web framework integration.",
    "technologies": [
      "rivet",
      "hono",
      "typescript"
    ],
    "tags": [],
    "noFrontend": true,
    "providers": {
      "vercel": {
        "name": "hono-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fhono-vercel&project-name=hono-vercel"
      }
    }
  },
  {
    "name": "hono-react",
    "displayName": "Hono + React",
    "description": "Example demonstrating full-stack Hono backend with React frontend integration.",
    "technologies": [
      "rivet",
      "hono",
      "react",
      "typescript"
    ],
    "tags": [
      "starter"
    ],
    "noFrontend": false,
    "providers": {
      "vercel": {
        "name": "hono-react-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fhono-react-vercel&project-name=hono-react-vercel"
      }
    }
  },
  {
    "name": "kitchen-sink",
    "displayName": "Kitchen Sink Example",
    "description": "Example project demonstrating all RivetKit features.",
    "technologies": [
      "rivet",
      "typescript"
    ],
    "tags": [],
    "noFrontend": false,
    "providers": {
      "vercel": {
        "name": "kitchen-sink-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fkitchen-sink-vercel&project-name=kitchen-sink-vercel"
      }
    }
  },
  {
    "name": "native-websockets",
    "displayName": "Native WebSockets",
    "description": "Demonstrates native WebSocket integration with Rivet Actors for real-time bidirectional communication.",
    "technologies": [
      "rivet",
      "websocket",
      "typescript"
    ],
    "tags": [
      "real-time"
    ],
    "noFrontend": false,
    "providers": {
      "vercel": {
        "name": "native-websockets-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fnative-websockets-vercel&project-name=native-websockets-vercel"
      }
    }
  },
  {
    "name": "next-js",
    "displayName": "Next.js",
    "description": "Minimal Next.js example demonstrating basic actor state management and real-time updates.",
    "technologies": [
      "rivet",
      "next-js",
      "react",
      "typescript"
    ],
    "tags": [
      "starter"
    ],
    "noFrontend": false,
    "providers": {}
  },
  {
    "name": "raw-websocket-handler-proxy",
    "displayName": "Raw WebSocket Handler Proxy",
    "description": "Demonstrates raw WebSocket handling using a proxy endpoint pattern for routing connections to actors.",
    "technologies": [
      "rivet",
      "websocket",
      "typescript"
    ],
    "tags": [],
    "noFrontend": false,
    "providers": {
      "vercel": {
        "name": "raw-websocket-handler-proxy-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fraw-websocket-handler-proxy-vercel&project-name=raw-websocket-handler-proxy-vercel"
      }
    }
  },
  {
    "name": "react",
    "displayName": "React Integration",
    "description": "Demonstrates React frontend integration with Rivet Actors.",
    "technologies": [
      "rivet",
      "react",
      "typescript"
    ],
    "tags": [],
    "noFrontend": false,
    "providers": {
      "vercel": {
        "name": "react-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Freact-vercel&project-name=react-vercel"
      }
    }
  },
  {
    "name": "stream",
    "displayName": "Stream Processor",
    "description": "Example project demonstrating real-time top-K stream processing.",
    "technologies": [
      "rivet",
      "typescript"
    ],
    "tags": [
      "real-time"
    ],
    "noFrontend": false,
    "providers": {
      "vercel": {
        "name": "stream-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Fstream-vercel&project-name=stream-vercel"
      }
    }
  },
  {
    "name": "trpc",
    "displayName": "tRPC Integration",
    "description": "Example project demonstrating tRPC integration.",
    "technologies": [
      "rivet",
      "trpc",
      "typescript"
    ],
    "tags": [],
    "noFrontend": true,
    "providers": {
      "vercel": {
        "name": "trpc-vercel",
        "deployUrl": "https://vercel.com/new/clone?repository-url=https%3A%2F%2Fgithub.com%2Frivet-gg%2Frivet%2Ftree%2Fmain%2Fexamples%2Ftrpc-vercel&project-name=trpc-vercel"
      }
    }
  }
];
